import React, { useEffect } from "react";
import "./style.css"; // Assuming you've moved CSS styles to an external file

const SvgFillEffect = () => {
  useEffect(() => {
    const handleScroll2 = () => {
      const totalHeight = document.body.scrollHeight; // 3202
      const windowHeight = window.innerHeight;        // 720
      
      const maxScroll = totalHeight - windowHeight + 48;   // 3202 - 720 = 2482
      const scrollPosition = window.scrollY;
      const scrollPercentage = scrollPosition / maxScroll;

      const svgHeight = 1065.79;
      const newMaskHeight = scrollPercentage * svgHeight;
      
      // Apply the new height to the mask rectangle
      const maskRect = document.getElementById("mask-rect-layer2");
      if (scrollPercentage > 0.49) {
        maskRect.setAttribute("height", newMaskHeight);
      }else{
        maskRect.setAttribute("height", 0);
      }
    };
    window.addEventListener("scroll", handleScroll2);
    return () => window.removeEventListener("scroll", handleScroll2);
  }, []);
  
  return (
    <div className="svg-fill-fx-wrapper d-flex justify-content-center">
      {/* SVG Layer 2 */}
      <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 747.11 1065.79">
        <defs>
          <style>
            {`
              .layer2-cls-1 {
                fill: none;
                stroke: #fff;
                stroke-miterlimit: 10;
                stroke-width: 3px;
              }
              .layer2-cls-2 {
                fill: #ffb600;
                font-family: "Source Sans 3", sans-serif;
                font-size: 200px;
                font-variation-settings: 'wght' 300;
                font-weight: 300;
              }
            `}
          </style>
          <clipPath id="revealMaskLayer2">
            <rect id="mask-rect-layer2" className="mask-rect-layer2" x="0" y="0" width="747.11" height="0" fill="white" />
          </clipPath>
        </defs>
        <g id="Layer_1-2" data-name="Layer 1" clipPath="url(#revealMaskLayer2)">
          <g>
            <path className="layer2-cls-1" d="M55.7,109.57c-5.68.32-25.78,2.16-40.29,18C-3.45,148.17-.73,179.23,9.41,197.86c11.93,21.92,36.12,30.25,66.86,37.71,113.39,27.55,155.78,5.59,209.14,32.14,23.25,11.57,54.84,35.45,80.57,91.29"/>
            <path className="layer2-cls-1" d="M691.41,109.57c5.68.32,25.78,2.16,40.29,18,18.86,20.6,16.14,51.66,6,70.29-11.93,21.92-36.12,30.25-66.86,37.71-113.52,27.58-155.75,6.04-209.14,32.14-23.69,11.58-56.16,35.74-82.79,93.01"/>
            <circle className="layer2-cls-2" cx="372.7" cy="370.14" r="12"/>
            <path className="layer2-cls-1" d="M372.7,381.43v684.36"/>
            <text className="layer2-cls-2" transform="translate(46.7 166)"><tspan x="0" y="0">{'{'}</tspan></text>
            <text className="layer2-cls-2" transform="translate(698.7 166) rotate(-180) scale(1 -1)"><tspan x="0" y="0">{'{'}</tspan></text>
          </g>
        </g>
      </svg>
      {/* SVG Layer 3 */}
      <svg id="Layer_3" data-name="Layer 3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 747.11 1065.79">
        <defs>
          <style>
            {`
              .layer3-cls-1 {
                fill: none;
                stroke: #321f66;
                stroke-miterlimit: 10;
                stroke-width: 3px;
                opacity: 0.6;
              }
              .layer3-cls-2 {
                fill: #ffb600;
                font-family: "Source Sans 3", sans-serif;
                font-size: 200px;
                font-variation-settings: 'wght' 300;
                font-weight: 300;
                opacity: 0.6;
              }
            `}
          </style>
        </defs>
        <g id="Layer_3-1" data-name="Layer 3">
          <g>
            <path className="layer3-cls-1" d="M55.7,109.57c-5.68.32-25.78,2.16-40.29,18C-3.45,148.17-.73,179.23,9.41,197.86c11.93,21.92,36.12,30.25,66.86,37.71,113.39,27.55,155.78,5.59,209.14,32.14,23.25,11.57,54.84,35.45,80.57,91.29"/>
            <path className="layer3-cls-1" d="M691.41,109.57c5.68.32,25.78,2.16,40.29,18,18.86,20.6,16.14,51.66,6,70.29-11.93,21.92-36.12,30.25-66.86,37.71-113.52,27.58-155.75,6.04-209.14,32.14-23.69,11.58-56.16,35.74-82.79,93.01"/>
            <circle className="layer3-cls-1" cx="372.7" cy="370.14" r="12"/>
            <path className="layer3-cls-1" d="M372.7,381.43v684.36"/>
            <text className="layer3-cls-2" transform="translate(46.7 166)"><tspan x="0" y="0">{'{'}</tspan></text>
            <text className="layer3-cls-2" transform="translate(698.7 166) rotate(-180) scale(1 -1)"><tspan x="0" y="0">{'{'}</tspan></text>
          </g>
        </g>
      </svg>
    </div>
  );
};

export default SvgFillEffect;